// extracted by mini-css-extract-plugin
export default {"container":"ActivityChips_component_container__j2zUd","chipRow":"ActivityChips_component_chipRow__gbpOW","chip":"ActivityChips_component_chip__lN5ER"};